import React from 'react';
import { EditToggle } from './assets/EditToggle';

export const DashboardEditModeToggle = () => {
  return (
    <div>
      <EditToggle />
    </div>
  )
}